import {
	createRouter,
	createWebHistory
} from 'vue-router'

import HomeView from '../views/Home/Home.vue'

const routes = [
	// {
	//   path: '/home',
	//   name: 'home',
	//   component: HomeView,

	// },
	{
		path: "/",
		redirect: "/web-site/home",
	},
	{
		path: '/web-site',
		name: 'web-site',
		component: () => import('@/layout/index.vue'),
		children: [{

				path: '/web-site/home',
				name: '网站首页',
				component: () => import('@/views/Home/Home.vue')


			},
			{
				path: '/web-site/about-us',
				name: '走进我们',
				component: () => import('@/views/AboutUs/aboutUs.vue')
			},
			{

				path: '/web-site/news',
				name: '新闻中心',
				component: () => import('@/views/News/news.vue')

			},
			{

				path: '/web-site/business',
				name: '业务方案',
				component: () => import('@/views/Business/business.vue')

			},
			{

				path: '/web-site/project',
				name: '项目案例',
				component: () => import('@/views/ProjectCases/project.vue')

			},
			{

				path: '/web-site/talent',
				name: '人才战略',
				component: () => import('@/views/TalentStrategy/talent.vue')

			},
			{

				path: '/web-site/contact',
				name: '联系我们',
				component: () => import('@/views/ContactUs/contact.vue')

			},
			{

				path: '/web-site/product',
				name: '产品中心',
				component: () => import('@/views/ProductCenter/product.vue')

			},
			{

				path: '/web-site/news-detail',
				name: '新闻中心详情',
				component: () => import('@/views/News/newsDetail.vue')

			}

		]

	}
	// {
	//   path: '/about',
	//   name: 'about',
	//   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
	// }
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes
})

export default router